/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added):not(.btn)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.innerHTML + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--noplyr)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    let plyrControls = false;
    if (el.closest(".mediavideo").classList.contains("mediavideo--controls")) {
      plyrControls = ["play", "play-large", "progress", "mute", "current-time"];
    }
    let plyrAutoplay = false;
    let plyrMuted = false;
    if (el.closest(".mediavideo").classList.contains("mediavideo--autoplay")) {
      plyrAutoplay = true;
      plyrMuted = true;
    }

    let player = new Plyr(plyr, {
      controls: plyrControls,
      hideControls: true,
      invertTime: false,
      autoplay: plyrAutoplay,
      muted: plyrMuted,
      tooltips: { controls: false, seek: false }
    });
    player.on("ready", event => {
      // Force mute on ready (otherwise it unmutes if you've previously unmuted a video on another page)
      player.muted = true;

      const container = player.elements.container;
      const embed = container.querySelector(".plyr__video-embed");

      if (!embed) {
        return;
      }

      const aspectRatioObserver = new MutationObserver(() => {
        const aspectRatio = embed.style.aspectRatio;
        if (aspectRatio) {
          container.style.aspectRatio = aspectRatio;
          aspectRatioObserver.disconnect(); // Stop observing once it's applied
        }
      });

      // Watch for attribute changes (like inline styles)
      aspectRatioObserver.observe(embed, {
        attributes: true,
        attributeFilter: ["style"]
      });
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - set body css 
  ========================================================================== */

function setCSSVariables(bgColour, fontColour = false, accentColour = false) {
  document.querySelector("body").style.setProperty("--bg-color", "var(--color-" + bgColour + ")");
  if (bgColour === "black" && !fontColour) {
    // If its black bg without a specific font colour set, make the font white
    document.querySelector("body").style.setProperty("--font-color", "var(--color-white)");
    document
      .querySelector("body")
      .style.setProperty("--font-color-opaque", "color-mix(in srgb, var(--color-white), transparent 75%)");
    document
      .querySelector("body")
      .style.setProperty("--bg-opaque", "color-mix(in srgb, var(--color-white), transparent 95%)");
  } else if (!fontColour) {
    // If its not a black bg without a specific font colour set, make the font black
    document.querySelector("body").style.setProperty("--font-color", "var(--color-black)");
    document
      .querySelector("body")
      .style.setProperty("--font-color-opaque", "color-mix(in srgb, var(--color-black), transparent 75%)");
    document
      .querySelector("body")
      .style.setProperty("--bg-opaque", "color-mix(in srgb, var(--color-black), transparent 95%)");
  } else {
    document.querySelector("body").style.setProperty("--font-color", "var(--color-" + fontColour + ")");
    document
      .querySelector("body")
      .style.setProperty("--font-color-opaque", "color-mix(in srgb, var(--color-" + fontColour + "), transparent 75%)");
    document
      .querySelector("body")
      .style.setProperty("--bg-opaque", "color-mix(in srgb, var(--color-" + fontColour + "), transparent 95%)");
  }

  if (!accentColour) {
    // If theres no accent then always use white
    document.querySelector("body").style.setProperty("--accent-color", "var(--color-white)");
  } else {
    document.querySelector("body").style.setProperty("--accent-color", "var(--color-" + accentColour + ")");
  }
}

/*  ==========================================================================
    GENERAL - Thank you page and 404 page min-height
  ========================================================================== */
const mainMinHeightInit = function () {
  const mainHeight100 = document.querySelectorAll(".main--height-100");

  if (!mainHeight100) {
    return;
  }

  function adjustMainHeight() {
    mainHeight100.forEach(function (el) {
      let headerHeight = document.querySelector(".siteheader").offsetHeight;
      let footerHeight = document.querySelector(".sitefooter").offsetHeight;
      let mainHeight = window.innerHeight - headerHeight - footerHeight;
      el.style.minHeight = mainHeight + "px";
    });
  }
  adjustMainHeight();
  window.addEventListener("resize", adjustMainHeight);
}; // mainMinHeightInit();
mainMinHeightInit();

/*  ==========================================================================
  GENERAL - Homepage Logo animation
========================================================================== */
// Handles the homepage animation that reveals the Disauthority logos.
const homepageAnimationInit = function () {
  const homepage = document.querySelector(".pageheader--home");

  if (!homepage) {
    return;
  }

  // These colours are apart of the brand colours (dusky-pink, rust, orange, green and blue).
  const colors = ["#cd6e6e", "#f08b61", "#ffc27b", "#b3f8c2", "#dbc2e7", "#99dbf7"];

  function animateLogos() {
    const logos = document.querySelectorAll(".pageheader__logos svg"); // Gather all the SVGs in an array so we can change the colours of the SVGs individually.
    let logoIndex = 0;
    let showing = true;
    let colorStep = 0;
    let firstCycleDone = false; // Track when all logos are active once for the logo in the navigation to appear.

    // This piece of code is responsible for making the logos continuously change color in a loop.
    setInterval(() => {
      logos.forEach((logo, i) => {
        const color = colors[(colorStep + i) % colors.length];
        applyColor(logo, color);
      });
      colorStep++;
    }, 100);

    const logoAnimation = setInterval(() => {
      if (showing) {
        logos[logoIndex].classList.add("active"); // We have looped through all the logos and adding the "active" class to display each logo.
        logoIndex++;

        if (logoIndex >= logos.length) {
          if (!firstCycleDone) {
            const navLogo = document.querySelector(".home .siteheader__logo");
            if (navLogo) {
              setInterval(() => {
                navLogo.classList.add("active"); // We show the logo in the navbar once
              }, 250);
            }
            firstCycleDone = true; // This mark that that all the logos have been revealed.
          }

          showing = false; // Hide all the other logos once they are all loaded.
          logoIndex = 0; // Restart from first logo.
        }
      } else {
        logos[logoIndex].classList.remove("active"); // Once all the logos are loaded. We hide the other logos from top to bottom. This is done by removing the "active" class.
        logoIndex++;

        if (logoIndex >= logos.length) {
          clearInterval(logoAnimation);
        }
      }
    }, 100);

    // This function changes the fill color of all the shapes inside the logo's SVG.
    function applyColor(logo, color) {
      logo
        .querySelectorAll("path, g, rect, circle, polygon, polyline, ellipse")
        .forEach(el => el.setAttribute("fill", color));
    }
  }

  // Run animation
  animateLogos();
};

homepageAnimationInit();

/*  ==========================================================================
    AJAX - Setup Variables
    ========================================================================== */

const filters = document.querySelector(".filters"),
  filtersForm = document.querySelector(".filters__form"),
  filtersToggles = document.querySelectorAll(".filters__toggle"),
  filtersMobileToggle = document.querySelector(".filters__togglemobile"),
  filterTags = document.querySelector(".filters__tags"),
  filterFieldsets = document.querySelector(".filters__fieldsets"),
  moreLikeThis = document.querySelector(".morelikethis");

let filtersInitialLoad = true;
let activeTagsNotEmpty = false;

/*  ==========================================================================
    AJAX - Go to previous scroll position
    ========================================================================== */

const scrollToCorrectPos = function () {
  let lastScroll = localStorage.getItem("scrollPosition" + php_variables.page_id);
  let previousScrollURL = localStorage.getItem("previousScrollURL" + php_variables.page_id);
  // If there is a stored scroll position and current filter matches the previous filter url, go to scroll position
  if (
    lastScroll &&
    lastScroll !== "0" &&
    lastScroll !== 0 &&
    previousScrollURL &&
    previousScrollURL === window.location.href
  ) {
    window.scroll({
      top: parseInt(localStorage.getItem("scrollPosition" + php_variables.page_id), 10),
      behavior: "instant"
    });
  } else {
    // If not then go pin user to the filters
    window.scrollTo({
      top: document.querySelector(".filters-pin").offsetTop - document.querySelector(".siteheader").clientHeight,
      behavior: "instant"
    });
  }
};

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

// LOAD POSTS IF MULTIPLE PAGES ARE DISPLAYING
const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page,
        format: button.dataset.format ? button.dataset.format : ""
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.closest(".paging").style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      scrollToCorrectPos();
    });
  }
};

// LOAD MORE POSTS ON CLICK OF LOAD MORE
const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page,
    format: button.dataset.format ? button.dataset.format : ""
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

// INIT LOAD MORE
const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  // Only run this on pages without filter form
  if (!filtersForm) {
    // Checking if the page paramenter is set
    const currentPage = new URL(window.location);
    let currentPageNum = currentPage.searchParams.get("pagenum");

    //If there is more than one page to load
    if (currentPageNum && currentPageNum > 1) {
      currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
      loadmoreLoadPostsMultiplePages(currentPageNum);
    }
  }

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    let scrollPosition = window.scrollY;
    localStorage.setItem("scrollPosition" + php_variables.page_id, scrollPosition);
    localStorage.setItem("previousScrollURL" + php_variables.page_id, window.location.href);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    AJAX - AJAX Companies filter
    ========================================================================== */

// GET CURRENT FILTERS FROM FORM DATA (e.g. checked checkboxes)
const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");

    if (checkedOptions.length > 0) {
      filter_data[el.name] = [...checkedOptions].map(x => x.value);
    }
  });

  return filter_data;
};

// UPDATE URL TO MATCH ACTIVE FILTERS
const filterUpdateURL = function (filterData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter-" + key + "=" + values;
    }
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  window.history.pushState({ path: newUrl }, "", newUrl);
};

// Setup up the Active Filters in the Tags section and Active States for filtersets
const filterDisplayActiveFilters = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const filtersitems = document.querySelectorAll(".filters__bar__filter");
  filtersitems.forEach(filtersitem => {
    filtersitem.classList.remove("filters__bar__filter--active");
  });

  const toggleBtns = document.querySelectorAll(".filters__toggle");
  toggleBtns.forEach(btn => {
    btn.classList.remove("filters__toggle--active");
  });

  // Reset tags
  document.querySelectorAll(".filters__bar__filter").forEach(function (filterBarFilter) {
    let filterName = filterBarFilter.dataset.name;
    filterBarFilter.querySelector(".filters__toggle__text").innerHTML = filterName;
  });

  // Close mobile filters
  filterFieldsets.classList.remove("filters__fieldsets--open");
  filtersMobileToggle.classList.remove("filters__togglemobile--open");

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__bar__filter[data-value='" + key + "']")
        .classList.add("filters__bar__filter--active");

      // Change the toggle to be the tag text
      // using "values[0]" as you can only selecr one filter at a time
      let filterBarFilter = document.querySelector(".filters__bar__filter[data-value='" + key + "']");
      let filter_input = document
        .querySelector("input[name='" + key + "'][value='" + values[0] + "']")
        .closest(".filters__fieldset__field");
      let filterName = filterBarFilter.dataset.name;
      let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;
      filterBarFilter.querySelector(".filters__toggle__text").innerHTML = filterName + ":" + filter_input_name;

      // Close fieldsets / dropdowns
      filtersToggles.forEach(toggle => {
        // close other toggles
        toggle.classList.remove("filters__toggle--open");
        // close the matching fieldset
        let filterValue = toggle.closest(".filters__bar__filter").dataset.value;
        document
          .querySelector(".filters__fieldset[data-value='" + filterValue + "']")
          .classList.remove("filters__fieldset--open");
      });

      // Set mobile filter to active
      if (!filtersMobileToggle.classList.contains("filters__togglemobile--active")) {
        filtersMobileToggle.classList.add("filters__togglemobile--active");
      }

      let activeToggleBtns = document.querySelectorAll(".filters__toggle[href='#" + key + "']");

      activeToggleBtns.forEach(btn => {
        btn.classList.add("filters__toggle--active");
      });
    }
  }

  if (Object.keys(filterData).length === 0) {
    // If no values, set mobile filter to in-active
    filtersMobileToggle.classList.remove("filters__togglemobile--active");
  } else {
    hasClassActive = true;
  }

  return hasClassActive;
};

// FILTER AND GET POSTS BASED ON FILTERS
const filterGetPosts = function (updateURL) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let pageData = false;

  let currentPageInput = document.querySelector("input.filters__currentpage");
  let currentPageNum = false;

  if (currentPageInput) {
    currentPageNum = currentPageInput.value;
  }

  if (filterData) {
    // Update url
    if (updateURL) {
      filterUpdateURL(filterData);

      // reseting current page
      if (currentPageInput) {
        currentPageNum = 1;
        currentPageInput.value = 1;
      }
    }

    activeTagsNotEmpty = filterDisplayActiveFilters(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || currentPageNum !== "1")) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // Start filtering
      loadmoreContainer.classList.add("filtering");

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        format: "row"
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page
          if (loadmoreBtn) {
            if (data.max_page < 2) {
              loadmoreBtn.closest(".paging").style.display = "none";
            } else {
              loadmoreBtn.closest(".paging").style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
          }

          // show "more like this" area if less than 4 items
          if (moreLikeThis) {
            if (document.querySelectorAll(".loadmore-container .tile").length <= 12) {
              if (!moreLikeThis.classList.contains("morelikethis--show")) {
                moreLikeThis.classList.add("morelikethis--show");
              }
            } else {
              moreLikeThis.classList.remove("morelikethis--show");
            }
          }

          lazyLoadInstance.update();

          const effects = document.querySelectorAll(".effect");
          effectsInit(effects);

          // If there is more than one page that needs to be loaded
          if (currentPageNum && currentPageNum > 1) {
            currentPageNum = currentPageNum > data.max_page ? data.max_page : currentPageNum;
            loadmoreLoadPostsMultiplePages(currentPageNum);
          } else {
            scrollToCorrectPos();
          }
          loadmoreContainer.classList.remove("filtering");
        },
        error: function (data) {}
      });
    }
  }
};

// INIT FILTER
const filterInit = function () {
  if (filtersForm && filtersForm.length) {
    // Get Posts based on Filter Form Data
    filterGetPosts(false);

    // Dropdowns open & close
    filtersToggles.forEach(toggle => {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.classList.contains("filters__toggle--open")) {
          this.classList.remove("filters__toggle--open");
          // hide the matching fieldset
          let filterValue = this.closest(".filters__bar__filter").dataset.value;
          document
            .querySelector(".filters__fieldset[data-value='" + filterValue + "']")
            .classList.remove("filters__fieldset--open");
        } else {
          // get this toggle value
          filtersToggles.forEach(otherToggle => {
            if (
              otherToggle.closest(".filters__bar__filter").dataset.value !==
              this.closest(".filters__bar__filter").dataset.value
            ) {
              // close other toggles
              otherToggle.classList.remove("filters__toggle--open");
              // close the matching fieldset
              let filterValue = otherToggle.closest(".filters__bar__filter").dataset.value;
              document
                .querySelector(".filters__fieldset[data-value='" + filterValue + "']")
                .classList.remove("filters__fieldset--open");
            } else {
              // open this one
              otherToggle.classList.add("filters__toggle--open");
              // open the matching fieldset
              let filterValue = otherToggle.closest(".filters__bar__filter").dataset.value;
              document
                .querySelector(".filters__fieldset[data-value='" + filterValue + "']")
                .classList.add("filters__fieldset--open");
            }
          });
        }
      });
    });

    // mobile dropdown open & close
    filtersMobileToggle.addEventListener("click", function (e) {
      e.preventDefault();
      if (filterFieldsets.classList.contains("filters__fieldsets--open")) {
        filtersMobileToggle.classList.remove("filters__togglemobile--open");
        filterFieldsets.classList.remove("filters__fieldsets--open");
      } else {
        filtersMobileToggle.classList.add("filters__togglemobile--open");
        filterFieldsets.classList.add("filters__fieldsets--open");
      }
    });

    // Filter on submit
    filtersForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      // Call the filtering post function
      filterGetPosts(true);
    });

    const filterCheckboxes = filtersForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // If this is checking a checkbox uncheck others
        if (checkbox.checked) {
          // Uncheck other checkboxes to only allow 1 filter per taxonomy
          let otherCheckboxes = checkbox
            .closest(".filters__fieldset__fields")
            .querySelectorAll(".filters__fieldset__field input");
          otherCheckboxes.forEach(otherCheckbox => {
            if (otherCheckbox !== checkbox) {
              otherCheckbox.checked = false;
            }
          });
        }
        // Submit for on checkbox click
        filterGetPosts(true);
      });
    });
  }
};

filterInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ============================================================c==============
    Scroll effect to change colour
    ========================================================================== */

const changePoints = document.querySelectorAll(".change-colours");

const changePointsInit = function (changePoints) {
  if (!changePoints) {
    return;
  }

  changePoints.forEach(function (val) {
    let bgColour = val.dataset.bg;
    let currentClasses = document.body.classList;
    let currentBgColour = "black";
    let currentFontColour = "white";
    let currentAccentColour = "white";
    if (currentClasses) {
      currentClasses.forEach(function (currentClass) {
        if (currentClass.includes("bg-")) {
          currentBgColour = currentClass.split("bg-").pop();
        }
        if (currentClass.includes("accent-")) {
          currentAccentColour = currentClass.split("accent-").pop();
        }
        if (currentClass.includes("color-")) {
          currentFontColour = currentClass.split("color-").pop();
        }
      });
    }
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          // add class for transition temporarily
          body.classList.add("transitioningdown-variables");
          setCSSVariables(bgColour);
          setTimeout(function () {
            body.classList.remove("transitioningdown-variables");
          }, 500);
        } else {
          body.classList.add("transitioningup-variables");
          setCSSVariables(currentBgColour, currentFontColour, currentAccentColour);
          setTimeout(function () {
            body.classList.remove("transitioningup-variables");
          }, 500);
        }
      },
      offset: "75%"
    });
  });
}; // changePointsInit();
changePointsInit(changePoints);

/*  ==========================================================================
    Homepage links hover
    ========================================================================== */

const homeheader = document.querySelector(".pageheader__homepageheader");
const pageheader = document.querySelector(".pageheader--home");
let linkhoverTimeout;
let secondaryLinkhoverTimeout;
let throttleTimeout;
let removeTimeout;
let img_count = 0;
let lastMouseX = 0;
let lastMouseY = 0;
let moveThreshold = 30; // pixels

if (homeheader && !isTouchDevice) {
  linkhoverInit();
}

function linkhoverInit() {
  linkhoverPreload();

  homeheader.querySelectorAll(".homepageheader__heading__link").forEach(function (headingLink) {
    // on move update links hover images
    headingLink.addEventListener(
      "mousemove",
      throttle(function (event) {
        let linkNo = headingLink.dataset.no;
        linkhoverMove(event, linkNo);
      }, 400) // <-- increased from 200ms
    );
    // on enter update css variables
    headingLink.addEventListener("mouseenter", function () {
      let bgColour = headingLink.dataset.bg;
      setCSSVariables(bgColour);
      if (pageheader && !pageheader.classList.contains("pageheader--home--activehover")) {
        pageheader.classList.add("pageheader--home--activehover");
      }
      clearTimeout(removeTimeout);
    });
    // on leave remove images, clear timeouts and reset variables
    headingLink.addEventListener("mouseleave", function () {
      // Immediately remove on mouseout?
      clearTimeout(throttleTimeout);
      throttleTimeout = false;
      clearTimeout(linkhoverTimeout);
      clearTimeout(secondaryLinkhoverTimeout);
      // hide / fade out the active items
      document.querySelectorAll(".linkhovers--active").forEach(function (linkhovers_active) {
        let linkhoveritems = linkhovers_active.querySelectorAll(".linkhovers__item");
        linkhoveritems.forEach(function (linkhoveritem) {
          linkhoveritem.classList.add("linkhovers__item--hide");
        });
      });
      // remove items and reset pageheader
      removeTimeout = setTimeout(function () {
        pageheader.classList.remove("pageheader--home--activehover");
        setCSSVariables("black");
        document.querySelectorAll(".linkhovers--active").forEach(function (linkhovers_active) {
          linkhovers_active.innerHTML = "";
        });
      }, 250);
    });
  });
} // linkhoverInit()

function linkhoverPreload() {
  const linkhover_items = document.querySelectorAll(".linkhovers__item");
  for (let i = 0; i < linkhover_items.length; i++) {
    // Get each background image
    let bg = linkhover_items[i]
      .querySelector(".linkhovers__item__img")
      .style.backgroundImage.slice(4, -1)
      .replace(/"/g, "");
    bg = bg.replace("url(", "").replace(")", "").replace(/\"/gi, "");
    // Preload the image
    let img = new Image();
    img.src = bg;
  }
}

function linkhoverMove(e, linkNo) {
  let event = e || window.event;
  const mouseX = event.clientX;
  const mouseY = event.clientY;

  // Only trigger image if mouse has moved more than X pixels
  const dx = Math.abs(mouseX - lastMouseX);
  const dy = Math.abs(mouseY - lastMouseY);

  if (dx < moveThreshold && dy < moveThreshold) {
    return;
  }

  lastMouseX = mouseX;
  lastMouseY = mouseY;

  linkhoverAdd(event, mouseX, mouseY, linkNo);
}

function linkhoverAdd(event, xPos, yPos, linkNo) {
  // Fade out main video
  const headinglink = document.querySelector(".homepageheader__heading__link[data-no='" + linkNo + "']");
  const linkhovers_list = document.querySelector(".linkhovers--list.linkhovers--" + linkNo);
  const linkhovers_active = document.querySelector(".linkhovers--active.linkhovers--" + linkNo);
  const linkhover_items = linkhovers_list.querySelectorAll(".linkhovers__item");

  let n_elements = linkhover_items.length;
  let img_count = Number(linkhovers_list.dataset.count);
  //let random = Math.floor(Math.random() * n_elements);
  let newLinkhover = linkhover_items[img_count].cloneNode(true);

  // increase image count to loop through images
  if (img_count === n_elements - 1) {
    linkhovers_list.dataset.count = "0";
  } else {
    linkhovers_list.dataset.count = img_count + 1;
  }

  // append new image
  linkhovers_active.append(newLinkhover);

  // make all other images set to hide image
  linkhovers_active.querySelectorAll(".linkhovers__item").forEach(function (linkhoverItem) {
    if (linkhoverItem !== newLinkhover) {
      linkhoverItem.classList.add("linkhovers__item--hideimg");
    }
  });

  // setup timeout to remove this new image
  linkhoverTimeout = setTimeout(() => {
    newLinkhover.classList.add("linkhovers__item--hide");
    secondaryLinkhoverTimeout = setTimeout(() => {
      newLinkhover.remove();
    }, 250);
  }, 1000);

  // Get height and width of the link
  let linkwidth = headinglink.offsetWidth;
  let linkheight = headinglink.offsetHeight;

  // get x and y position relevant to link - have to use this setup to work on all browsers
  let mouseLeft = event.offsetX || event.pageX - $(event.target).offset().left;
  let mouseTop = event.offsetY || event.pageY - $(event.target).offset().top;

  let percentageX = (mouseLeft - linkwidth / 2) / linkwidth;
  let percentageY = (mouseTop - linkheight / 2) / linkheight;

  // Get height and width of the wrapper
  let halfimgwidth = newLinkhover.offsetWidth / 2;
  let halfimgheight = newLinkhover.offsetHeight / 2;

  let random_limit = 10;
  let random_offset = Math.floor(Math.random() * (random_limit * 2));
  let random_modifier = random_limit - random_offset;

  // Get x and y mouse position, remove the pageheader offset and half of the wrapper size
  let x = window.innerWidth * 0.5 - halfimgwidth;
  let y = window.innerHeight * 0.5 - halfimgheight;

  // apply percentage offset based on mouse position
  x = x + percentageX * (window.innerWidth / 5);
  y = y + percentageY * (window.innerHeight / 5);

  // apply random modifier
  x = x + random_modifier;
  y = y + random_modifier;

  // Position the wrapper using the x and y
  newLinkhover.style.left = x + "px";
  newLinkhover.style.top = y + "px";

  // Negative position the pageheader_body within the wrapper to keep it in the same position as the main pageheader_body
  newLinkhover.querySelector(".homepageheader").style.left = 0 - x + "px";
  newLinkhover.querySelector(".homepageheader").style.top = 0 - y + "px";
} // linkhoverMove()

function throttle(callback, wait) {
  return function (e) {
    if (throttleTimeout) {
      return;
    }
    throttleTimeout = setTimeout(() => (callback(e), (throttleTimeout = undefined)), wait);
  };
}

/*  ==========================================================================
    DVD Bounce Effect
    ========================================================================== */

let animationId; // Variable to hold the requestAnimationFrame ID
const dvdElement = document.querySelector(".dvd-logo");
const hoverElements = document.querySelectorAll(".bounce-dvd-on-hover");
const footer = document.querySelector(".sitefooter");

function toggleFooterColorBlack() {
  if (footer) {
    if (footer.classList.contains("bg-black")) {
      footer.classList.remove("bg-black", "color-white");
    } else {
      footer.classList.add("bg-black", "color-white");
    }
  }
}

function toggleOpacityBottomFooterElements() {
  var bottomFooterElements = [
    ...document.querySelectorAll(".sitefooter__navs"),
    ...document.querySelectorAll(".sitefooter__logosvg")
  ];

  bottomFooterElements.forEach(element => {
    if (element.classList.contains("o-10")) {
      element.classList.remove("o-10");
    } else {
      element.classList.add("o-10");
    }
  });
}

function bounceElement(startInRandomPosition = false) {
  const pathElements = dvdElement.querySelectorAll("svg path");
  const container = dvdElement.parentElement;

  let containerWidth = container.offsetWidth;
  let containerHeight = container.offsetHeight;
  let dvdElementWidth = dvdElement.offsetWidth; // Cache DVD element dimensions
  let dvdElementHeight = dvdElement.offsetHeight;

  // Animation state variables
  let currentXPos = startInRandomPosition ? Math.random() * (containerWidth - dvdElementWidth) : 0;
  let currentYPos = startInRandomPosition ? Math.random() * (containerHeight - dvdElementHeight) : 0;
  let xVelocity = 1.3;
  let yVelocity = 1.3;

  const dvdColors = ["#cd6e6e", "#f08b61", "#ffc27b", "#f9da75", "#b3f8c2", "#99dbf7", "#adb0f5", "#dbc2e7"];
  let lastColorIndex = -1;

  container.style.position = "relative"; // Set the container to relative positioning

  function moveDvdLogo() {
    currentXPos += xVelocity;
    currentYPos += yVelocity;

    if (currentXPos + dvdElementWidth >= containerWidth || currentXPos < 0) {
      xVelocity = -xVelocity;
      changeColor();
    }

    if (currentYPos + dvdElementHeight >= containerHeight || currentYPos < 0) {
      yVelocity = -yVelocity;
      changeColor();
    }

    const roundedXPos = Math.round(currentXPos);
    const roundedYPos = Math.round(currentYPos);

    // Use transform for smoother rendering
    dvdElement.style.transform = `translate(${roundedXPos}px, ${roundedYPos}px)`;

    animationId = requestAnimationFrame(moveDvdLogo);
  }

  function changeColor() {
    let newColorIndex;
    do {
      newColorIndex = Math.floor(Math.random() * dvdColors.length);
    } while (newColorIndex === lastColorIndex);

    // Change the fill color of all paths in the SVG
    pathElements.forEach(path => {
      path.style.fill = dvdColors[newColorIndex];
    });
    lastColorIndex = newColorIndex;

    if (hoverElements.length > 0) {
      // Update the background color of hover elements to match the DVD color
      hoverElements.forEach(element => {
        element.style.color = dvdColors[newColorIndex];

        Array.from(element.children).forEach(child => {
          child.style.setProperty("--font-color", dvdColors[newColorIndex]);
        });
      });
    }
  }

  // Set initial random color at the beginning of the animation
  changeColor(); // Set a random color for the DVD logo and hover elements

  function handleResize() {
    // Update container dimensions on window resize
    containerWidth = container.offsetWidth;
    containerHeight = container.offsetHeight;

    // Update dvdElement dimensions as well
    dvdElementWidth = dvdElement.offsetWidth;
    dvdElementHeight = dvdElement.offsetHeight;

    // Adjust the DVD's position if it exceeds the new container dimensions
    if (currentXPos + dvdElementWidth > containerWidth) {
      currentXPos = containerWidth - dvdElementWidth; // Keep it within bounds
    }

    if (currentYPos + dvdElementHeight > containerHeight) {
      currentYPos = containerHeight - dvdElementHeight; // Keep it within bounds
    }

    // Reapply the transform to make sure the DVD logo is repositioned
    dvdElement.style.transform = `translate(${Math.round(currentXPos)}px, ${Math.round(currentYPos)}px)`;
  }

  // Add resize event listener to handle container resizing
  window.addEventListener("resize", handleResize);

  // Start the animation
  moveDvdLogo();

  // Return a function to stop the animation
  return () => {
    cancelAnimationFrame(animationId);
    window.removeEventListener("resize", handleResize);
  };
}
if (!isTouchDevice) {
  // Attach event listeners
  hoverElements.forEach(element => {
    let stopBounce; // Variable to store the stop function

    element.addEventListener("mouseover", () => {
      toggleFooterColorBlack();
      toggleOpacityBottomFooterElements();
      dvdElement.style.display = "block"; // Show the DVD logo
      stopBounce = bounceElement(true); // Start bouncing and store the stop function
      setTimeout(function () {
        dvdElement.style.opacity = 1; // Show the DVD logo on delay to prevent "swooping" at beginning on animation on transform
      }, 200);
    });

    element.addEventListener("mouseout", () => {
      toggleFooterColorBlack();
      toggleOpacityBottomFooterElements();
      if (stopBounce) {
        stopBounce(); // Stop bouncing on mouseout
        dvdElement.style.display = "none"; // Hide the DVD logo
        dvdElement.style.opacity = 0; // Hide the DVD logo
        element.style.color = "inherit"; // Reset the color of the hover element
        Array.from(element.children).forEach(child => {
          child.style.setProperty("--font-color", "inherit");
        });
      }
    });
  });
}

const autoDvdBounce = function () {
  const autoDvdBounceElement = document.querySelector(".auto-dvd-bounce");

  if (autoDvdBounceElement) {
    dvdElement.style.display = "block"; // Show the DVD logo

    // Ensure dvdElement is properly defined and accessible here
    if (dvdElement) {
      const stopBounce = bounceElement(true); // Start bouncing and store the stop function
      setTimeout(function () {
        dvdElement.style.opacity = 1; // Show the DVD logo on delay
      }, 200);
    }
  }
};
autoDvdBounce();

/*  ==========================================================================
    Animate - Credit Rows images
    ========================================================================== */

const creditRows = document.querySelectorAll(".credit");

const creditRowsInit = function (creditRows) {
  if (!creditRows) {
    return;
  }

  creditRows.forEach(function (item) {
    // Move image on hover on desktop
    item.addEventListener("mousemove", function (e) {
      let creditImg = item.querySelector(".credit__name__link__image");
      let itemRect = item.getBoundingClientRect();
      var valueX = (e.clientX - itemRect.left) / 10;
      var valueY = (e.clientY - itemRect.top) / 10;
      creditImg.style.transform = "translate(" + valueX + "px, " + valueY + "px)";
    });
  });
}; // creditRowsInit();
creditRowsInit(creditRows);

/*  ==========================================================================
    Animate - Before & After Images
    ========================================================================== */

const beforeAfters = document.querySelectorAll(".module--before-after");

function setPercentage(item) {
  if (item) {
    let afterImage = item.querySelector(".before-after__imgwrap--after");
    let wrap = item.querySelector(".before-after__wrap");
    if (afterImage) {
      const wrapBounding = item.getBoundingClientRect();
      const wrapOptions = {
        top: wrapBounding.top + window.scrollY,
        bottom: wrapBounding.bottom + window.scrollY
      };
      const moduleHeight = wrapOptions.bottom - wrapOptions.top;
      const currentPosition = window.scrollY + window.innerHeight * 0.3 - wrapOptions.top;
      if (currentPosition < 0) {
        afterImage.style.height = `0%`;
      } else {
        const scrollPercentage = (currentPosition / (moduleHeight * 0.7)) * 100;
        afterImage.style.height = `${scrollPercentage}%`;
      }
    }
  }
}

const beforeAftersInit = function (beforeAfters) {
  if (!beforeAfters) {
    return;
  }

  beforeAfters.forEach(function (item) {
    setPercentage(item);
    window.addEventListener("scroll", function () {
      setPercentage(item);
    });
    window.addEventListener("resize", function () {
      setPercentage(item);
    });
  });
}; // beforeAftersInit();
beforeAftersInit(beforeAfters);

/*  ==========================================================================
    Animate - Awards Rows animate in when more than 10
  ========================================================================== */

const awardModule = document.querySelectorAll(".module--awards-list");

const awardRowsInit = function (awardModule) {
  if (!awardModule) {
    return;
  }

  awardModule.forEach(function (module) {
    const awards = module.querySelectorAll(".awards-list__award");
    const loadMoreBtn = module.querySelector(".awards-list__load-more-btn");
    const awardsToShow = 10; // Number of awards to display initially

    // If there are more than 10 awards, hide the rest
    if (awards.length > awardsToShow) {
      for (let i = awardsToShow; i < awards.length; i++) {
        awards[i].style.display = "none";
      }
      // Show the "Load More" button if there are hidden awards
      loadMoreBtn.style.display = "inline-block";
      // Add click event listener for the "Load More" button
      loadMoreBtn.addEventListener("click", function (event) {
        event.preventDefault();
        for (let i = awardsToShow; i < awards.length; i++) {
          awards[i].style.display = "block";
        }
        // Hide the button after all awards are shown
        loadMoreBtn.style.display = "none";
      });
    }
  });
}; // awardRowsInit
awardRowsInit(awardModule);

/*  ==========================================================================
    Popup - Click Close
    ========================================================================== */

const popup = document.querySelector(".popup");

const popupCloseInit = function (popup) {
  if (!popup) {
    return;
  }

  const popupClose = popup.querySelector(".popup__close");

  popupClose.addEventListener("click", function () {
    popup.classList.remove("effect--ready", "effect");
  });
};

// popupCloseInit();
popupCloseInit(popup);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplaytimeout ? elem.dataset.autoplaytimeout : 3000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/* ==========================================================================
    CAROUSEL Module Quote Carousel
    ========================================================================== */

const quoteModule = document.querySelectorAll(".module--quote--carousel");

const quoteCarouselInit = function (quoteCarousel) {
  if (quoteCarousel.length <= 0) {
    return;
  }

  $(quoteCarousel).each(function () {
    const currentParent = $(this);
    const currentCarousel = currentParent.find(".owl-carousel");
    const innerLinks = $(currentParent).find(".navigation__item");

    $(innerLinks).each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
          const slideLocation = $(this).attr("data-slide");
          currentCarousel.trigger("refresh.owl.carousel");
          currentCarousel.trigger("to.owl.carousel", slideLocation - 1);
          $(currentParent).find(".navigation__item").removeClass("active");
          $(this).addClass("active");
        }
      });
    });

    currentCarousel.on("changed.owl.carousel", function (event) {
      var index = event.item.index + 1;
      var currentItem = $(currentParent)
        .find(".owl-item:nth-child(" + index + ")")
        .find(".quote__content");
      var currentKey = $(currentItem).data("key");
      $(currentParent).find(".navigation__item").removeClass("active");
      $(currentParent)
        .find(".navigation__item[data-slide=" + currentKey + "]")
        .addClass("active");
    });
  });
}; // quoteCarouselInit();
quoteCarouselInit(quoteModule);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const mobnavOverlay = document.querySelector(".mobnav-overlay");
const mobnavOpenclass = "mobnav--open";
const mobnavOverlayOpenclass = "mobnav-overlay--show";

const mobnavInit = function () {
  if (!mobnav) {
    return;
  }
  // Open mobnav on click the toggle
  const mobnavToggle = mobnav.querySelector(".mobnav__toggle");
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!mobnav.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnav.classList.add(mobnavOpenclass);
      mobnavOverlay.classList.add(mobnavOverlayOpenclass);
    } else {
      // IT'S OPEN...
      mobnav.classList.remove(mobnavOpenclass);
      mobnavOverlay.classList.remove(mobnavOverlayOpenclass);
    }
  });

  mobnavOverlay.addEventListener("click", function (e) {
    e.preventDefault();
    // IT'S OPEN...
    mobnav.classList.remove(mobnavOpenclass);
    mobnavOverlay.classList.remove(mobnavOverlayOpenclass);
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
	NAVIGATION - Add class to siteheader on scroll
	========================================================================== */
const siteHeader = document.querySelector(".siteheader");

// Scroll event listener
const SiteHeaderInit = function () {
  let originalTop;

  // Function to calculate the header's original position
  function calculateOriginalTop() {
    originalTop = siteHeader.getBoundingClientRect().top + window.scrollY;
  }

  // Function to update sticky state
  function updateHeaderSticky() {
    if (originalTop == 0) {
      // If header is at the top of the page, set it to 2px to stop it immediately triggering (before scroll)
      originalTop = 2;
    }
    if (window.scrollY >= originalTop) {
      siteHeader.classList.add("sticky");
    } else {
      siteHeader.classList.remove("sticky");
    }
  }

  // Initial calculation
  calculateOriginalTop();
  updateHeaderSticky();

  // Listen to scroll
  window.addEventListener("scroll", updateHeaderSticky);

  // Recalculate on resize
  window.addEventListener("resize", () => {
    // Remove sticky first to get correct position
    siteHeader.classList.remove("sticky");
    calculateOriginalTop();
    updateHeaderSticky();
  });
};

SiteHeaderInit();
